import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from '@mui/material'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ITenderProtocolData } from 'types/final-protocol'

const StyledTableCell = styled(TableCell)(() => ({
  padding: 0,
  width: '100%',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 0,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled': {
    background: 'rgba(128,128,128, 0.1)',
  },
}))

type Props = {
  protocolData: ITenderProtocolData
}

export const TenderEvaluationCriteriaTable = ({ protocolData }: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields } = useFieldArray({
    control,
    name: `tenderEvaluationCriteria`,
  })

  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          background: '#FFF',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>{t('ordinal')}</TableCell>
            <TableCell>
              {t('criterion').charAt(0).toUpperCase() + t('criterion').slice(1)}
            </TableCell>
            <TableCell>{t('bid-weight')}</TableCell>
            <TableCell colSpan={protocolData.tenderEvaluationCriteria.items.length}>
              {t('supplier-name')}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3} />
            {protocolData.tenderEvaluationCriteria.items?.map((score, idx) => {
              return (
                <StyledTableCell>
                  <Controller
                    name={`tenderEvaluationCriteria.items.${idx}.orgName`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ width: 'inherit' }}>
            <TableCell>1</TableCell>
            <TableCell>{t(`tender-evaluation-criteria-type-PROCUREMENT`)}</TableCell>
            <StyledTableCell>
              <Controller
                name={`tenderEvaluationCriteria.procurementBidWeight`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} fullWidth variant="outlined" />
                )}
              />
            </StyledTableCell>
            {protocolData.tenderEvaluationCriteria.items?.map((score, idx) => {
              return (
                <StyledTableCell key={idx}>
                  <Controller
                    name={`tenderEvaluationCriteria.items.${idx}.procurementScore`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
              )
            })}
          </TableRow>
          <TableRow sx={{ width: 'inherit' }}>
            <TableCell>2</TableCell>
            <TableCell>{t(`tender-evaluation-criteria-type-TECHNICAL`)}</TableCell>
            <StyledTableCell>
              <Controller
                name={`tenderEvaluationCriteria.technicalBidWeight`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} fullWidth variant="outlined" />
                )}
              />
            </StyledTableCell>
            {protocolData.tenderEvaluationCriteria.items?.map((score, idx) => {
              return (
                <StyledTableCell key={idx}>
                  <Controller
                    name={`tenderEvaluationCriteria.items.${idx}.technicalScore`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
              )
            })}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
